import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (!isVisible) return null;

  /*
    STACKING PLAN (right side, measured from bottom of viewport):
    ─────────────────────────────────────────────────────────────
    MOBILE (< md):
      bottom-nav bar       ≈ 56px  (your fixed nav)
      gap                    12px
      scroll-to-top button   68px  → 40px tall → top edge at 108px
      gap                    12px
      chat bubble           120px  → 48px tall → top edge at 168px
      gap                     8px
      chat panel            176px  (opens upward)

    DESKTOP (≥ md):
      No bottom-nav.
      scroll-to-top  bottom: 24px, right: 82px  (sits LEFT of chat bubble)
      chat bubble    bottom: 24px, right: 20px
      — they sit side by side, no overlap.
  */

  return (
    <>
      <button
        onClick={scrollToTop}
        aria-label="Scroll to top"
        className="
          fixed
          z-[1090]
          bg-orange-400 hover:bg-orange-500
          text-white
          w-10 h-10
          rounded-full
          shadow-lg hover:shadow-xl
          flex items-center justify-center
          transition-all duration-200
          hover:scale-110
          active:scale-95
          scroll-to-top-btn
        "
      >
        <ChevronUp className="h-5 w-5" />
      </button>

      <style>{`
        /* Mobile: stacked above bottom-nav, below chat bubble */
        .scroll-to-top-btn {
          bottom: 68px;
          right: 16px;
        }
        /* Desktop: sit to the LEFT of chat bubble, both at same height */
        @media (min-width: 768px) {
          .scroll-to-top-btn {
            bottom: 24px;
            right: 82px;
          }
        }
      `}</style>
    </>
  );
};

export default ScrollToTopButton;